module.exports = __webpack_public_path__ + "img/订单归集ico.975afd31.png";